/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This is used in AnnotationLayer
 */
export abstract class IPDFLinkService {
  abstract get pagesCount(): number;
  abstract set page(value: number);
  abstract get page(): number;
  abstract set rotation(value: number);
  abstract get rotation(): number;
  abstract get isInPresentationMode(): boolean;
  abstract set externalLinkEnabled(value: boolean);
  abstract get externalLinkEnabled(): boolean;
  abstract goToDestination(dest: string | any[]): Promise<void>;
  abstract goToPage(val: number | string): void;
  abstract addLinkAttributes(link: HTMLAnchorElement, url: string, newWindow?: boolean | undefined): void;
  abstract getDestinationHash(dest: any): string;
  abstract getAnchorUrl(hash: any): string;
  abstract setHash(hash: string): void;
  abstract executeNamedAction(action: string): void;
  abstract executeSetOCGState(action: object): void;
}
